import { FC, Fragment } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectMedia } from 'store/media/mediaSelectors';
// Components
import { Loader, Message } from 'components/Utilities';
// i18next
import { useTranslation } from 'react-i18next';
import MediaItem from './MediaItem';

const MediaList:FC = () => {
  const { t } = useTranslation('common');
  
  const media = useAppSelector(selectMedia);

  const images = media.filter(m => m.type === 'image');
  const videos = media.filter(m => m.type === 'video');

  if ( !media ) return <Loader />;
  if ( media.length === 0 ) return <Message text="No media file(s)" />;
  return (
    <div>
      {!!images.length && (
        <Fragment>
          <h2
            className="text-md font-bold text-white leading-5 mb-4"
          >{t('common.images')}</h2>
          <div className="flex flex-wrap gap-4 pb-4">
            {images.map(image => (
              <MediaItem key={image._id} media={image} />
            ))}
          </div>
        </Fragment>
      )}
      {!!videos.length && (
        <Fragment>
          <h2
            className="text-md font-bold text-white leading-5 mb-4"
          >{t('common.videos')}</h2>
          <div className="flex flex-wrap gap-4 pb-4">
            {videos.map(video => (
              <MediaItem key={video._id} media={video} />
            ))}
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default MediaList;
